// Format for the unabbreviated month name, day and year
// More formatting options here: https://date-fns.org/v2.21.1/docs/format
var LongDateFormats = /*#__PURE__*/function (LongDateFormats) {
  LongDateFormats["MONTH_DAY"] = "MMMM d";
  LongDateFormats["MONTH_DAY_YEAR"] = "MMMM d, yyy";
  return LongDateFormats;
}(LongDateFormats || {}); // Format for the abbreviated month name, day and year
// More formatting options here: https://date-fns.org/v2.21.1/docs/format
var ShortDateFormats = /*#__PURE__*/function (ShortDateFormats) {
  ShortDateFormats["MONTH_DAY"] = "MMM. d";
  ShortDateFormats["MONTH_DAY_YEAR"] = "MMM. d, yyy";
  return ShortDateFormats;
}(ShortDateFormats || {});
/**
 * A helper function to get the correct date formats based on month. For
 * example, MONTH_DAY_YEAR for January 1, 2005 would return "Jan. 1, 2005" and
 * for July 1, 2005 would return "July 1, 2005".
 *
 * This follows the AP style guide for month abbreviation which applies to
 * Jan., Feb., Aug., Sept., Oct., Nov. and Dec.
 */
var getDateFormats = function getDateFormats(date) {
  switch (date.getMonth()) {
    case 0:
    case 1:
    case 7:
    case 8:
    case 9:
    case 10:
    case 11:
      return ShortDateFormats;
    default:
      return LongDateFormats;
  }
};
export default getDateFormats;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/utils/dist/esm/date/getDateFormats.js
// module id = 1240
// module chunks = 11